import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/components/Home.vue';
import Callback from '@/components/Callback.vue';
import Lobby from '@/components/Lobby.vue';
import Game from '@/components/games/Game.vue';
import GameView from '@/components/games/GameView.vue';
import EndedGame from '@/components/ended/EndedGame.vue';
import SetUserNameModale from '@/components/SetUserNameModale.vue';
import Profile from '@/components/profile/Profile.vue';
import ProfileView from '@/components/profile/ProfileView.vue';
import Rating from '@/components/Rating.vue';
import SupportLCT from '@/components/SupportLCT.vue';
import Rules from '@/components/Rules.vue';
import Contact from '@/components/Contact.vue';
import ChangePicture from '@/components/profile/ChangePicture.vue';
import MentionsLegales from '@/components/MentionsLegales.vue';
import PolitiqueConfidentialite from '@/components/PolitiqueConfidentialite.vue';
import AdminUsers from '@/components/admin/AdminUsers.vue';
import AdminPayements from '@/components/admin/AdminPayments.vue';
import AdminCognito from '@/components/admin/AdminCognito.vue';
import Statistics from '@/components/admin/Stats.vue';
import PrepareGame from '@/components/games/PrepareGame.vue';
import RoomHome from '@/components/salle/RoomHome.vue';
import iam from '../iam';

// Tournoi en salle : écran de salle et pages des joueurs chargés à la demande (QR code inutile ailleurs)
const RoomReferee = () => import('@/components/salle/RoomReferee.vue');
const RoomScreen = () => import('@/components/salle/RoomScreen.vue');
const RoomJoin = () => import('@/components/salle/RoomJoin.vue');
const RoomPlayer = () => import('@/components/salle/RoomPlayer.vue');

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback,
    },
    {
      path: '/username',
      name: 'username',
      component: SetUserNameModale,
    },
    {
      path: '/lobby',
      name: 'Lobby',
      component: Lobby,
    },
    {
      path: '/picture',
      name: 'ChangePicture',
      component: ChangePicture,
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
    },
    {
      path: '/profiles/:userId',
      name: 'Profiles',
      component: ProfileView,
      props: true,
    },
    {
      path: '/rating',
      name: 'Rating',
      component: Rating,
    },
    {
      path: '/games/:activeGameId',
      name: 'Game',
      component: Game,
      props: true,
    },
    {
      path: '/prepare-games/:activeGameId',
      name: 'PrepareGame',
      component: PrepareGame,
      props: true,
    },
    {
      path: '/view/games/:activeGameId',
      name: 'GameView',
      component: GameView,
      props: true,
    },
    {
      path: '/ended-games/:gameId',
      name: 'EndedGame',
      component: EndedGame,
      props: true,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
    {
      path: '/support',
      name: 'SupportLCT',
      component: SupportLCT,
    },
    {
      path: '/rules',
      name: 'Rules',
      component: Rules,
    },
    {
      path: '/mention-legales',
      name: 'MentionsLegales',
      component: MentionsLegales,
    },
    {
      path: '/confidentialite',
      name: 'PolitiqueConfidentialite',
      component: PolitiqueConfidentialite,
    },
    {
      path: '/admin/users',
      name: 'AdminUsers',
      component: AdminUsers,
    },
    {
      path: '/admin/payments',
      name: 'AdminPaiements',
      component: AdminPayements,
    },
    {
      path: '/admin/cognitousers',
      name: 'AdminCognito',
      component: AdminCognito,
    },
    {
      path: '/admin/statistics',
      name: 'AdminStatistics',
      component: Statistics,
    },
    {
      path: '/salle',
      name: 'RoomHome',
      component: RoomHome,
    },
    {
      path: '/salle/:id',
      name: 'RoomReferee',
      component: RoomReferee,
      props: true,
    },
    {
      path: '/salle/:id/ecran',
      name: 'RoomScreen',
      component: RoomScreen,
      props: true,
    },
    {
      path: '/salle/:id/joueur',
      name: 'RoomPlayer',
      component: RoomPlayer,
      props: true,
    },
    {
      path: '/s/:code',
      name: 'RoomJoin',
      component: RoomJoin,
      props: true,
    },
  ],
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

const publicRoutes = ['Home', 'Callback', 'Rules', 'Rating', 'MentionsLegales', 'PolitiqueConfidentialite',
  'RoomScreen', 'RoomJoin', 'RoomPlayer'];

router.beforeEach(to => (publicRoutes.includes(to.name) || iam.isAuthenticated() ? true : '/'));

export default router;
